import React from 'react';
import { Typography } from '@mui/material';
import { OmnibarCitizenArea, OmnibarContext } from './omnibar-interfaces';

interface OmnibarActiveContextProps {
  context: OmnibarContext;
  citizenArea?: OmnibarCitizenArea;
  citizenName?: string;
  serviceProviderUnitName?: string;
  opticLabel?: string;
}

export function OmnibarActiveContext({ context, citizenArea, citizenName, serviceProviderUnitName, opticLabel }: OmnibarActiveContextProps) {
  const parts = describeContext(context, citizenArea, citizenName, serviceProviderUnitName, opticLabel);
  if (parts.length === 0) return null;

  return (
    <Typography variant="caption" component="div" color="text.secondary" sx={{ px: 2, pt: 1 }} data-testid="omnibar-active-context">
      {parts.join(' · ')}
    </Typography>
  );
}

function describeContext(context: OmnibarContext, citizenArea?: OmnibarCitizenArea, citizenName?: string, serviceProviderUnitName?: string, opticLabel?: string) {
  if (context === 'company') return ['Virksomhed'];
  if (context !== 'citizen') return [];

  const citizen = citizenName ? `Borger: ${citizenName}` : 'Borger';
  if (citizenArea === 'serviceprovider') {
    return [citizen, 'Udfører', serviceProviderUnitName].filter((part): part is string => !!part);
  }
  return [citizen, 'Myndighed', opticLabel].filter((part): part is string => !!part);
}
